// ArtsAwards.js
import './css/mycss.css';
import { Cards } from './Cards.js';
import img1 from './images/a1.png';
import img2 from './images/a2.png';
import img3 from './images/a3.png';
import img4 from './images/a4.jpg';
import img5 from './images/a5.png';
import img6 from './images/a6.png';
import img7 from './images/a7.png';

/* ----------------- Exporting for Search Integration ----------------- */

export const artsAwardsData = [
  {
    category: "Arts",
    htext: "Sangeet Natak Akademi Award",
    ptext: "India’s primary state honour for living performing artists.",
    img1,
    ialt: "Sangeet Natak Akademi Award",
    modalContent: `
      <b>Established:</b> 1952</br>
      <b>Type:</b> National award in music, dance and drama<br/>
      <b>First Awarded:</b>1955</br>
      <b>First Recipient: </b> Ustad Ahmed Jan Thirakwa in music</br>
      <b> Material:</b>Copper</br>
      <b> Symbolism:</b> Honours outstanding contribution to India’s performing arts heritage</br>
      <b> Awarded For:</b>Outstanding achievement in music, dance, theatre and related performing arts</br> 
      <br/><b><a href='https://en.wikipedia.org/wiki/Sangeet_Natak_Akademi_Award'>wiki link</a></b> 
    `
  },
  {
    category: "Arts",
    htext: "Sangeet Natak Akademi Fellowship (Akademi Ratna)",
    ptext: "A very rare “Ratna” title reserved for the greatest performing-arts legends.",
    img1: img2,
    ialt: "Sangeet Natak Akademi Fellowship",
    modalContent: `
      <b>Established:</b>1954</br>
      <b>Type:</b> Lifetime fellowship; highest honour of the Akademi.<br/>
      <b>First Awarded:</b>1954</br>
      <b>First Recipient: </b>Ariyakudi Ramanuja Iyengar, Karaikudi Sambasiva Iyer and Prithviraj Kapoor</br>
      <b> Symbolism:</b>Recognises a lifetime of pre-eminent service to Indian performing arts</br>
      <b> Awarded For:</b>Eminence and lifetime achievement in music, dance, drama and related fields</br>
      <br/><b><a href='https://en.wikipedia.org/wiki/Sangeet_Natak_Akademi_Fellowship'>wiki link</a></b> 
    `
  },
  {
    category: "Arts",
    htext: "Sahitya Akademi Award",
    ptext: "The standard-setting annual prize for serious Indian literature.",
    img1: img3,
    ialt: "Sahitya Akademi Award",
    modalContent: `
      <b>Established:</b>1954</br>
      <b>Type:</b> Annual national literary award across Indian languages<br/>
      <b>First Awarded:</b>1855</br>
      <b>First Recipient: </b>Makhanlal Chaturvedi</br>
      <b> Material:</b>Copper</br>
      <b> Symbolism:</b>Celebrates literary excellence and encourages high-quality writing in Indian languages</br>
      <b> Awarded For:</b>Outstanding books of literary merit in 24 recognised languages</br>
      <br/><b><a href='https://en.wikipedia.org/wiki/Sahitya_Akademi_Award'>wiki link</a></b> 
    `
  },
  {
    category: "Arts",
    htext: "Lalit Kala Akademi National Award",
    ptext: "The main government-backed badge of recognition for Indian visual artists.",
    img1: img4,
    ialt: "Lalit Kala Akademi National Award",
    modalContent: `
      <b>Established:</b>1954</br>
      <b>Type:</b>National visual-arts awards (painting, sculpture, graphics, etc.)<br/>
      <b>First Awarded:</b>1955</br>
      <b>First Recipient: </b>Jamini Roy</br>
      <b> Symbolism:</b>Acknowledges innovation and excellence in Indian visual arts</br>
      <b> Awarded For:</b>Notable works shown in the National Exhibition of Art representing contemporary visual advances</br>
      <br/><b><a href='https://en.wikipedia.org/wiki/Lalit_Kala_Akademi_National_Award'>wiki link</a></b> 
    `
  },
  {
    category: "Arts",
    htext: "National Film Award",
    ptext: "India’s top state honour that shapes the canon of serious Indian cinema.",
    img1: img5,
    ialt: "National Film Award",
    modalContent: `
      <b>Established:</b>1954</br>
      <b>Type:</b>National film awards across multiple categories<br/>
      <b>First Awarded:</b>1953 (ceremony held 1954)</br>
      <b>First Recipient: </b>"Shyamchi Aai" by P. K. Atre</br>
      <b> Material:</b>Silver</br>
      <b> Symbolism:</b>Promotes technically and aesthetically excellent cinema</br>
      <b> Awarded For:</b>Best works in Indian cinema across feature, non-feature and writing</br>
      <br/><b><a href='https://en.wikipedia.org/wiki/National_Film_Award'>wiki link</a></b> 
    `
  },
  {
    category: "Arts",
    htext: "Jnanpith Award",
    ptext: "The “lifetime summit” award for an Indian author’s creative work.",
    img1: img6,
    ialt: "Jnanpith Award",
    modalContent: `
      <b>Established:</b>1961</br>
      <b>Type:</b>India’s highest literary honour<br/>
      <b>First Awarded:</b>1965</br>
      <b>First Recipient: </b>G. Sankara Kurup</br>
      <b> Material:</b>Bronze</br>
      <b> Symbolism:</b>Represents cultural integration of India</br>
      <b> Awarded For:</b>Outstanding literary contribution</br>
      <br/><b><a href='https://en.wikipedia.org/wiki/Jnanpith_Award'>wiki link</a></b> 
    `
  },
  {
    category: "Arts",
    htext: "Kalidas Samman",
    ptext: "A prestigious Madhya Pradesh honour for cultural excellence.",
    img1: img7,
    ialt: "Kalidas Samman",
    modalContent: `
      <b>Established:</b>1980</br>
      <b>Type:</b>State award, nationally recognised<br/>
      <b>First Awarded:</b>1981</br>
      <b>First Recipient: </b>Semmangudi Srinivasa Iyer & Mallikarjun Mansur</br>
      <b> Awarded For:</b>Classical music, dance, theatre & visual arts</br>
      <br/><b><a href='https://en.wikipedia.org/wiki/Kalidas_Samman'>wiki link</a></b> 
    `
  }
];

/* ----------------- Page Component (No Search Logic Here) ----------------- */

function ArtsAwards() {
  return (
    <div>
      <h1 className="heading">Arts Awards</h1>
      <h3 className="head2">Celebrating excellence in creativity and artistic achievement.</h3>

      <div className="search-cards-container">
        {artsAwardsData.map((award, i) => (
          <Cards
            key={i}
            htext={award.htext}
            ptext={award.ptext}
            img1={award.img1}
            ialt={award.ialt}
            btext="Learn more"
            modalContent={award.modalContent}
          />
        ))}
      </div>
    </div>
  );
}

export default ArtsAwards;
